import React, { useState } from 'react';
import ScreeningResultsIcon from '../../../assets/icons/screeningResultsIcon.svg';
import SlantArrowBlueIcon from '../../../assets/icons/slantArrowBlueIcon.svg';
import mustGuidePDF from '../../../assets/pdf/MUST_Guide.pdf';
import { TypographyStyledBlack } from '../../../shared/components/tileLinkStyled/style';
import { Box, Button } from '@mui/material';
import { BlueHeaderWithText } from '../../estimatingRequirements/peng2018/blueHeaderWithText';
import { TypographyH4White } from '../style';
import { metaDataSelector } from '../../../store/globalSelectors';
import { useAppSelector } from '../../../store/hooks';
import { NavigationButtons } from '../../../shared/components/navigationButtons';

export const ScreeningResults = () => {
  const {
    patientInformation,
    alternativeMeasures,
    malnutritionScreening,
    optedOptions: { routeArr }
  } = useAppSelector(metaDataSelector);
  const { bmi } = patientInformation;
  const { estBMI_ulna } = alternativeMeasures;
  const { must } = malnutritionScreening;
  const { totalScore } = must;

  const openPDF = () => {
    window.open(mustGuidePDF, '_blank');
  };

  const bmiToBeDisplayed: number = bmi ? bmi : estBMI_ulna;

  const getNextRoute = () => {
    if (routeArr.length) return routeArr[0];
    else return '/summary';
  };

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          backgroundColor: '#F2F2F2',
          p: 0,
          top: 0,
          left: 0,
          height: '100%'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            marginTop: '1.875rem'
          }}
        >
          <Box
            sx={{
              backgroundColor: '#fff',
              height: '100px',
              width: '100px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img alt="Screening Result Icon" src={ScreeningResultsIcon} />
          </Box>

          <TypographyStyledBlack sx={{ margin: '3.125rem 0' }}>
            SCREENING RESULTS
          </TypographyStyledBlack>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <BlueHeaderWithText
              text1={'BMI (kg/m<sup>2</sup>):'}
              value1={String(bmiToBeDisplayed)}
              text2={'MUST Score:'}
              value2={String(totalScore)}
              single={false}
              customWidth="75%"
              customMarginBottom="1rem"
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              marginTop: '3.125rem'
            }}
          >
            <Button
              variant="outlined"
              sx={{
                marginBottom: 2,
                height: '2.5rem',
                padding: '0 0.9375rem',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                textAlign: 'center',
                lineHeight: 'normal',
                borderRadius: '100px',
                backgroundColor: '#007ACC',
                color: '#FFF'
              }}
              onClick={openPDF}
              data-testid="#must-screening-result-popup-btn"
            >
              <TypographyH4White sx={{ margin: '0.625rem' }}>
                Must management guideline
              </TypographyH4White>

              <Box
                sx={{
                  height: '1.5625rem',
                  width: '1.5625rem',
                  backgroundColor: '#FFF',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginLeft: '0.625rem'
                }}
              >
                <img
                  src={SlantArrowBlueIcon} // Replace with the actual path to your image
                  alt="icon"
                  style={{
                    height: '0.875rem',
                    width: '0.75rem',
                    objectFit: 'contain'
                  }}
                />
              </Box>
            </Button>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
          <NavigationButtons nextRoute={getNextRoute()} nextDisabled={false} />
        </Box>
      </Box>
    </>
  );
};
